import { getAllISOCodes } from "iso-country-currency";

// export const PDF_URL = process.env.REACT_APP_PDF_URL;
export const PDF_URL = process.env.REACT_APP_PDF_URL;
export const documentServerURL = process.env.REACT_APP_API_URL_LOCAL;
export const syncFusionLicense = process.env.REACT_APP_SYNC_FUSION_LICENSE;
export const syncServiceUrl = process.env.REACT_APP_SYNC_SERVICE_URL;
export const BulkUploadType = ".xls,.xlsx,.csv,.xlsm,.xltx,.xltm";
export const uploadAgreementType = ".doc,.docx,.pdf";


export const API_URL = (() => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_API_URL_LOCAL
  } else if (process.env.NODE_ENV === "production") {
    return process.env.REACT_APP_API_URL_DEV
  } else {
    return process.env.REACT_APP_API_URL_DEV
  }
})();

export const WS_BASE_URL = (() => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_WS_URL_LOCAL;
  } else if (process.env.NODE_ENV === "production") {
    return process.env.REACT_APP_WS_URL_PROD;
  } else {
    return process.env.REACT_APP_WS_URL_DEV;
  }
})();
console.log(WS_BASE_URL, 'outside')

export const BASE_URL = (() => {
  if (process.env.NODE_ENV === "development") {
    return process.env.REACT_APP_BASE_URL_LOCAL;
  } else if (process.env.NODE_ENV === "production") {
    return process.env.REACT_APP_BASE_URL_PROD;
  } else {
    return process.env.REACT_APP_BASE_URL_DEV;
  }
})();


export const formatIndianDate = (isoDate) => {
  const date = new Date(isoDate);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  if (isoDate) {
    return `${day}-${month}-${year}`;
  } else {
    return "";
  }
};


export const agreementOptions = [
  { value: "Addendum Agreement", label: "Addendum Agreement" },
  { value: "Agreement to Sale", label: "Agreement to Sale" },
  {
    value: "Brand Store and Technology Integration Agreement",
    label: "Brand Store and Technology Integration Agreement",
  },
  { value: "Cloud Agreement", label: "Cloud Agreement" },
  { value: "Code of Conduct", label: "Code of Conduct" },
  { value: "Collaboration Agreement", label: "Collaboration Agreement" },
  {
    value: "Commercial Distribution Agreement",
    label: "Commercial Distribution Agreement",
  },
  { value: "Consultant Agreement", label: "Consultant Agreement" },
  { value: "Contractor Agreement", label: "Contractor Agreement" },
  {
    value: "Corporate Research Agreement",
    label: "Corporate Research Agreement",
  },
  { value: "Data Processing Agreement", label: "Data Processing Agreement" },
  { value: "Data Security Agreement", label: "Data Security Agreement" },
  { value: "Declaration Letter", label: "Declaration Letter" },
  { value: "Distribution Agreement", label: "Distribution Agreement" },
  { value: "Eco Partner Agreement", label: "Eco Partner Agreement" },
  { value: "Engagement Letter", label: "Engagement Letter" },
  { value: "Freelance Writer Agreement", label: "Freelance Writer Agreement" },
  {
    value: "General Employment Agreement",
    label: "General Employment Agreement",
  },
  {
    value: "General Terms and Conditions",
    label: "General Terms and Conditions",
  },
  { value: "Joint Venture Agreement", label: "Joint Venture Agreement" },
  { value: "Lease Agreement", label: "Lease Agreement" },
  { value: "License Agreement", label: "License Agreement" },
  { value: "Loan Agreement", label: "Loan Agreement" },
  { value: "Management Agreement", label: "Management Agreement" },
  { value: "Master Service Agreement", label: "Master Service Agreement" },
  {
    value: "Memorandum of Understanding",
    label: "Memorandum of Understanding",
  },
  { value: "Non-Disclosure Agreement", label: "Non-Disclosure Agreement" },
  {
    value: "Operation and Management Agreement",
    label: "Operation and Management Agreement",
  },
  { value: "Partnership Agreement", label: "Partnership Agreement" },
  {
    value: "Professional Service Agreement",
    label: "Professional Service Agreement",
  },
  { value: "Purchase Order", label: "Purchase Order" },
  { value: "Referral Agreement", label: "Referral Agreement" },
  { value: "Reseller Agreement", label: "Reseller Agreement" },
  { value: "SaaS Agreement", label: "SaaS Agreement" },
  { value: "Scope of Work", label: "Scope of Work" },
  { value: "Security Service Agreement", label: "Security Service Agreement" },
  { value: "Service Agreement", label: "Service Agreement" },
  { value: "Shareholders’ Agreement", label: "Shareholders’ Agreement" },
  { value: "Share Purchase Agreement", label: "Share Purchase Agreement" },
  {
    value: "Share Subscription Agreement",
    label: "Share Subscription Agreement",
  },
  { value: "Share Transfer Agreement", label: "Share Transfer Agreement" },
  { value: "Sponsorship Agreement", label: "Sponsorship Agreement" },
  { value: "Supply Agreement", label: "Supply Agreement" },
  { value: "Vendor Agreement", label: "Vendor Agreement" },
  { value: "Work Order", label: "Work Order" },
];

export const natureOptions = [
  { value: "customer", label: "Customer" },
  { value: "vendor", label: "Vendor" },
  { value: "partnership", label: "Partnership" },
];

export const agreementStatus = [
  { value: "FRESH_REQUEST", label: "Fresh Request" },
  { value: "UNDER_NEGOTIATION", label: "Under Negotiation" },
  { value: "UNDER_EXECUTION", label: "Under Execution" },
  { value: "EXECUTED", label: "Executed" },
  { value: "TRANSACTION_CLOSED", label: "Transaction Closed" },
];

export const invoiceFrequencyOptions = [
  { value: "One Time", label: "One Time" },
  { value: "Monthly", label: "Monthly" },
  { value: "Quarterly", label: "Quarterly" },
  { value: "Half Yearly", label: "Half Yearly" },
  { value: "Anually", label: "Anually" },
  { value: "Event Based", label: "Event Based" },
];

export const getBoxColor = (status) => {
  switch (status) {
    case "approved":
      return "border-green-400 bg-green-50 dark:border-green-500 dark:bg-green-200";
    case "rejected":
      return "border-red-400 bg-red-50 dark:border-red-500 dark:bg-red-200";
    case "sent for approval":
      return "border-pink-400 bg-pink-50 dark:border-pink-500 dark:bg-pink-200";
    case "draft":
      return "border-orange-400 bg-orange-50 dark:border-orange-500 dark:bg-orange-200";
    case "pending":
      return "border-yellow-400 bg-yellow-50 dark:border-yellow-500 dark:bg-yellow-200";
    case "approval not required":
      return "border-gray-400 bg-gray-100 dark:border-gray-400 dark:bg-gray-200";
    default:
      return "border-gray-200 bg-gray-50 dark:border-gray-500 dark:bg-gray-200";
  }
};
export const getCircleColor = (status) => {
  switch (status) {
    case "approved":
      return { stroke: "#22c55e", fill: "#dcfce7", darkStroke: "#16a34a", darkFill: "#14532d" };
    case "rejected":
      return { stroke: "#ef4444", fill: "#fee2e2", darkStroke: "#b91c1c", darkFill: "#7f1d1d" };
    case "sent for approval":
      return { stroke: "#ec4899", fill: "#fce7f3", darkStroke: "#be185d", darkFill: "#70163a" };
    case "draft":
      return { stroke: "#f97316", fill: "#ffedd5", darkStroke: "#c2410c", darkFill: "#7c2d12" };
    case "pending":
      return { stroke: "#eab308", fill: "#fef3c7", darkStroke: "#b45309", darkFill: "#78350f" };
    case "approval not required":
      return { stroke: "#6b7280", fill: "#f3f4f6", darkStroke: "#374151", darkFill: "#111827" };
    default:
      return { stroke: "#d1d5db", fill: "#f9fafb", darkStroke: "#4b5563", darkFill: "#1f2937" };
  }
};
export const getStatusBadgeColor = (status) => {
  switch (status) {
    case "approved":
      return "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-300";
    case "rejected":
      return "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-300";
    case "sent for approval":
      return "bg-pink-100 text-pink-700 dark:bg-pink-800 dark:text-pink-300";
    case "draft":
      return "bg-orange-100 text-orange-700 dark:bg-orange-800 dark:text-orange-300";
    case "pending":
      return "bg-yellow-100 text-yellow-700 dark:bg-yellow-800 dark:text-yellow-300";
    case "approval not required":
      return "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300";
    default:
      return "bg-gray-100 text-gray-600 dark:bg-gray-900 dark:text-gray-400";
  }
};



